import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import Post          from '@common/post/_post';

import ContentsModal from 'contents_modal';
// -------------------------------------------------------

class AchievementProjectScore extends React.Component {
  changeMode(mode) {
    this.props.change_ev.bind(this)('mode', mode);
  }
  // -------------------------------------------------------
  
  closeEvent() {
    this.props.change_ev.bind(this)('project_mode', null);
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let projects = this.props.projects;
    
    let project_mode = this.props.project_mode;
    
    projects = projects.filter((d) => {
      if( this.props.project_mode == d.project_mode ) return d;
    });
    
    let modeList = [
      { id: 'reach', name: 'リーチ数' },
      { id: 'likes', name: 'いいね数' },
      { id: 'plays', name: '再生数' },
    ];
    
    let modeObj = '';
    modeList.map((d) => { if( d.id == this.props.mode ) modeObj = d; });
    
    // カラムリスト
    let scoreColumns = [
      { id: 'post_count',     name: '投稿数',                          fmt: 'int' },
      { id: modeObj.id,       name: modeObj.name,                      fmt: 'int' },
      { id: 'contract_money', name: '報酬',                            fmt: 'int' },
      { id: 'cp',             name: '1'+ modeObj.name +'あたりの単価', fmt: 'float' },
    ];
    
    projects = projects.map((d) => {
      modeList.map((m) => {
        if( d[m.id] == undefined ) d[m.id] = 0;
        d.reports.map((r) => { d[m.id] += r[m.id]; });
        
        if( d.reports.length > 0 ) d[m.id] = (d[m.id] / d.reports.length);
        if( isNaN(d[m.id]) || d[m.id] == 'Infinity' ) d[m.id] = 0;
      });
      
      return d;
    });
    console.log(projects);
    
    return (
      <ContentsModal
        view      = {( project_mode == null ) ? false : true}
        width     = {'calc(100% - 150px)'}
        height    = {'calc(100% - 180px)'}
        max_width = {600}
        close_ev  = {this.closeEvent.bind(this)}
        html      = {
          <div className="modal-item">
            <div className="achievements-project-score">
              
              { (project_mode == 'ok' ) &&
                <div className="influencer-achievements-header">
                  <div className="button-contents-tab">
                    <h6>レポートの指標</h6>
                    <ul className="mode-select">
                      { modeList.map((d, key) => {
                        let flg = (d.id == this.props.mode) ? 'on' : 'off';
                        return <li key={key} className={flg} onClick={this.changeMode.bind(this, d.id)}>{d.name}</li>;
                      })}
                    </ul>
                  </div>
                </div>
              }
              
              <ul className="project-status">
                { projects.map((d, key) => {
                  return (
                    <li key={key}>
                      {(d.is_ng == 0) ? <h3>{d.title}</h3> : <h3 className="is-ng">{d.title}</h3>}
                      <h4 className="status"><span>{d.progress_name}</span></h4>
                      
                      { (d.reports.length > 0) &&
                        <div className="achievements-report-score">
                          { scoreColumns.map((c, ckey) => {
                            return (
                              <div key={ckey} className="item">
                                <h6>{c.name}</h6>
                                { (c.fmt == 'int') && <p>{Utils.viewInt(d[c.id])}</p> }
                                { (c.fmt == 'float') && <p>{d[c.id].toFixed(1)}</p> }
                              </div>
                            );
                          })}
                        </div>
                      }
                      
                      { (d.ng_reason != null) && <div className="ng-reason">{d.ng_reason}</div> }
                      { (d.is_ng == 1 && d.ng_reason == null) && <div className="ng-reason">NG理由を取得できませんでした</div> }
                      
                      { (d.insight_complete_date != null) && <h5 className="insight-date">インサイト提出日: {Utils.setDate(d.insight_complete_date, 'YYYY/M/D')}</h5> }
                      { (d.reports.length > 0 ) &&
                        <div className="post-list">
                          { d.reports.map((p, pkey) => {
                            return <Post key={pkey} data={p} base={this.props.base} account={data} project_id={p.project_id} is_api={true} report_edit={false} />
                          })}
                        </div>
                      }
                      { (d.is_ng == 0 && d.reports.length == 0) && <div className="post-list">投稿がありません</div> }
                      
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        }
      />
      
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default AchievementProjectScore;